import { WelcomeModalIcon } from "../WelcomeModalIcon/WelcomeModalIcon";

export const OneClickTradingSlide = () => {
  return (
    <div className="relative left-1/2 mt-3 h-54 w-80 -translate-x-1/2 bg-[url('/images/components/welcome-settings-slide-light.png')] bg-contain bg-no-repeat dark:bg-[url('/images/components/welcome-settings-slide-dark.png')]">
      <WelcomeModalIcon
        hideText
        name="pointer-arrow"
        bgClassName="size-12"
        iconClassName="text-2xl ml-1"
        className="absolute -top-3 left-1/2 -translate-x-1/2"
      />
    </div>
  );
};
